// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import STRIPE_LOGO from "../../../../assets/logo-stripe.png";

const ComponentBlocks = ({ blocks, customClassName, handleOnClick }) => (
  <div className={`componentblocks-container ${customClassName} `}>
    {blocks.map(block => (
      <div
        key={block.id}
        className={`componentblocks-block clickable-button ${
          block.isDisabled ? "is-disabled" : ""
        } `}
        data-test={`component-btn-${block.id}`}
        onClick={event => handleOnClick(event, block.id)}
        onKeyPress={() => {}}
        role="button"
        tabIndex="0">
        {/* -------- Block Button Label Section -------- */}
        {block.isBeta && <span className="new-tag">New</span>}
        {/* -------- Block Button Icon Section -------- */}
        {block.id !== "add-payment-button" ? (
          <FontAwesomeIcon
            icon={block.icon}
            className="componentblocks-block-icon"
          />
        ) : (
          <img
            className="stripe-logo componentblocks-block-icon"
            alt="stripe"
            src={STRIPE_LOGO}
          />
        )}

        {/* -------- Block Button Text Section -------- */}
        <span
          id={block.id}
          data-test={block.id}
          className="componentblocks-block-label">
          {block.label}
        </span>
      </div>
    ))}
  </div>
);

export default ComponentBlocks;



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/PlusButtonAddComponentsV2/ComponentBlocks/index.js